import { createContext, useEffect, useState } from "react";
import axios from "axios";
// import useToast from "../hooks/ToastHook";

const loginUrl = process.env.REACT_APP_AUTH_API_URL || "http://localhost:9000/"
const loginPage = process.env.REACT_APP_LOGIN_PAGE || "http://localhost:3000/"
const AuthContext = createContext({});

const saveOnStorage = (credentials) => window.localStorage.setItem('@eztoque-credentials', JSON.stringify(credentials));
const removeFromStorage = () => window.localStorage.removeItem('@eztoque-credentials');
const getFromStorage = () => JSON.parse(window.localStorage.getItem('@eztoque-credentials'));

const api = axios.create({
	baseURL: loginUrl
});

api.interceptors.response.use(r => r, e => {
	// showAxiosError(e);
	return Promise.reject(e);
});

export const AuthProvider = ({ children }) => {

	// const { showAxiosError, showError } = useToast();
	const [ logged, setLogged ] = useState(false);
	const [ credentials, setCredentials ] = useState();
	const [ authorizationCode, setAuthorizationCode ] = useState();
	const [ loadingCredentials, setLoadingCredentials ] = useState(true);

	useEffect(() => {
		const params = new URLSearchParams(document.location.search);
		const authorizationParam = params.get('authorization');
		if (authorizationParam) {
			setAuthorizationCode(authorizationParam);
		} else {
			const storedCredentials = getFromStorage();
			setCredentials(storedCredentials);
		}
	}, []);

	useEffect(() => {
		console.log('authorizationcode', authorizationCode);
		if (authorizationCode) {
			setLoadingCredentials(true);
			api.get('authorization/' + authorizationCode).then(({ data }) => {
				setCredentials(data);
				window.history.replaceState(null, '', window.location.pathname);
			});
		}
	}, [authorizationCode]);

	useEffect(() => {
		if (credentials) {
			saveOnStorage(credentials);
			setLoadingCredentials(false);
		}
		setLogged(!!credentials);
	}, [credentials]);

	useEffect(() => {
		const timer = setTimeout(() => {
			if (!logged) {
				window.location.href = loginPage;
			}
		}, 3000);
		return () => clearTimeout(timer);
	}, [logged]);

	useEffect(() => {
		const refresh = () => {
			if (credentials?.expires && new Date(credentials.expires) < new Date()) {
				api.post('login/refresh', { refreshToken: credentials.refreshToken }).then(({ data }) => {
					console.log(data.expires);
					setCredentials(data);
				}).catch(() => {
					window.location.href = loginPage;
				});
			}
		}

		refresh();

		const timer = setInterval(() => {
			refresh();	
		}, 600000);
		return () => clearInterval(timer);
	}, [credentials]);

	const clearCredentials = () => {
		removeFromStorage();
		setCredentials(null);
	}

	if (loadingCredentials) return (
		<div>Carregando...</div>
	);

	return (
		<AuthContext.Provider value={{ token: credentials.token, logged, clearCredentials }}>
			{children}
		</AuthContext.Provider>
	);
}

export default AuthContext;